"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledinputLabel = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _material = require("@mui/material");

var _Visibility = _interopRequireDefault(require("@mui/icons-material/Visibility"));

var _VisibilityOff = _interopRequireDefault(require("@mui/icons-material/VisibilityOff"));

var _excluded = ["error", "label", "required"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var StyledOutlinedInput = (0, _styledComponents.default)(_material.OutlinedInput)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: 52px;\n  border-radius: 4px;\n  background-color: ", ";\n  .MuiInputBase-input  {\n    font-size: 16px;\n    font-weight: 500;\n    height: 100%;\n    padding: 0 14px;\n  }\n  &.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline  {\n    border: 1px solid ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.color.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.secondary.main;
});
var StyledFormControl = (0, _styledComponents.default)(_material.FormControl)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 36px;\n"])));
var StyledFormHelperText = (0, _styledComponents.default)(_material.FormHelperText)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    background-color: ", ";\n    color: ", ";\n    border-radius: 4px;\n    padding: 10px;\n    margin-top: 0;\n    margin: 0;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.error.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.error.main;
});
var StyledinputLabel = (0, _styledComponents.default)(_material.InputLabel)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\ncolor: ", ";\nfont-size: 22px;\nfont-weight: 500;\nfont-stretch: normal;\nfont-style: normal;\nline-height: normal;\nletter-spacing: normal;\nposition: unset;\npointer-events: unset;\ntext-transform: uppercase;\nmargin-left: -13px;\nmargin-bottom: -8px;\n\n.MuiInputLabel-asterisk {\n  color: ", ";\n  font-size: 22px;\n}\n\n&.Mui-focused {\n  color: ", ";\n}\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.secondary.main;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.primary.main;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.secondary.main;
});
exports.StyledinputLabel = StyledinputLabel;

var PasswordInput = function PasswordInput(_ref8) {
  var error = _ref8.error,
      label = _ref8.label,
      required = _ref8.required,
      rest = (0, _objectWithoutProperties2.default)(_ref8, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showPassword = _useState2[0],
      setShowPassword = _useState2[1];

  var handleMouseDownPassword = function handleMouseDownPassword(event) {
    return event.preventDefault();
  };

  return /*#__PURE__*/_react.default.createElement(StyledFormControl, {
    fullWidth: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(StyledinputLabel, {
    error: !!error,
    shrink: true,
    htmlFor: label,
    required: required
  }, label), /*#__PURE__*/_react.default.createElement(StyledOutlinedInput, Object.assign({
    variant: "outlined"
  }, rest, {
    id: label,
    "aria-describedby": "password-helper-text",
    type: showPassword ? 'text' : 'password',
    error: !!error,
    endAdornment: /*#__PURE__*/_react.default.createElement(_material.InputAdornment, {
      position: "end"
    }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
      "aria-label": "toggle password visibility",
      onClick: function onClick() {
        return setShowPassword(!showPassword);
      },
      onMouseDown: handleMouseDownPassword,
      edge: "end",
      size: "large"
    }, showPassword ? /*#__PURE__*/_react.default.createElement(_Visibility.default, null) : /*#__PURE__*/_react.default.createElement(_VisibilityOff.default, null)))
  })), error && /*#__PURE__*/_react.default.createElement(StyledFormHelperText, {
    id: "password-helper-text"
  }, error.message));
};

PasswordInput.defaultProps = {
  error: null,
  required: false
};
var _default = PasswordInput;
exports.default = _default;